import { render } from "./MySelectAlt.vue?vue&type=template&id=104cf2d8&scoped=true"
import script from "./MySelectAlt.vue?vue&type=script&lang=js"
export * from "./MySelectAlt.vue?vue&type=script&lang=js"

import "./MySelectAlt.vue?vue&type=style&index=0&id=104cf2d8&lang=css"
import "./MySelectAlt.vue?vue&type=style&index=1&id=104cf2d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104cf2d8"]])

export default __exports__